var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import GlobalVue from "../../globalVue";
import MyService from "../service/MyService.vue";
var MsgDialog = (function (_super) {
    __extends(MsgDialog, _super);
    function MsgDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.msgInfo = {};
        return _this;
    }
    MsgDialog.prototype.mounted = function () {
        this.msgInfo = this.msgInfo;
    };
    MsgDialog.prototype.close = function () {
        this.$closeDialog();
    };
    MsgDialog.prototype.toServicePage = function () {
        var that = this;
        GlobalVue.$emit("addTab", {
            component: MyService,
            title: "会员服务",
            name: "service",
            showExist: true,
            cprops: {
                service_status: this.msgInfo.do_button == '去升级' ? 0 : 1
            },
            callback: function () {
                that.$closeDialog();
            }
        });
    };
    MsgDialog = __decorate([
        Component
    ], MsgDialog);
    return MsgDialog;
}(VueDialog));
export default MsgDialog;
